export enum DocumentListObserve {
    RESPONSE = 'response',
    BODY = 'body',
    EVENTS = 'events'
}